import type { PropsWithChildren } from "react";
import type { GroupsContextType } from "./GroupsContext.ts";
import { GroupsContext } from "./GroupsContext.ts";

export const GroupsContextProvider = ({ children, ...props }: PropsWithChildren<GroupsContextType>) => (
  <GroupsContext value={props}>{children}</GroupsContext>
);
